import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { Route, RouterModule } from "@angular/router";
import { NgxsModule } from "@ngxs/store";
import { JsonSchemaState } from "@vp/data-access/json-schema";
import {
  RequestMetaDataResolver,
  RequestMetaDataResolverService,
  RequestMetaDataStateModule
} from "@vp/data-access/request-meta-data";
import {
  FilteredTagsResolver,
  FilteredTagsResolverService,
  PageMenuItemsResolver,
  TagsState
} from "@vp/data-access/tags";
import { UiSchemaState } from "@vp/data-access/ui-schema";
import { globalPermissions } from "@vp/models";
import { AuthenticationCanActivateGuard } from "@vp/shared/guards";
import { TagManagerState } from "@vp/tag-manager/data-access/tag-manager-state";
import {
  TagManagerShellComponent,
  TagManagerShellModule
} from "@vp/tag-manager/ui/tag-manager-shell";
import { ngxPermissionsGuard } from "ngx-permissions";
import { TagManagerPendingChangesGuard } from "../services/tag-manger-pending-changes.guard.service";
import { adminPermissions } from "@vp/models";

export const tagManagerFeatureRoutes: Route[] = [
  {
    path: "",
    component: TagManagerShellComponent,
    canActivate: [AuthenticationCanActivateGuard, ngxPermissionsGuard],
    canDeactivate: [TagManagerPendingChangesGuard],
    resolve: {
      metaData: RequestMetaDataResolver,
      tags: FilteredTagsResolver,
      pageMenuItems: PageMenuItemsResolver
    },
    data: {
      permissions: {
        only: [globalPermissions.AdminTagsPage.View],
        redirectTo: "/loggedin"
      },
      metaData: {
        "feature-name": "tagManager"
      },
      breadcrumb: "tagManagerNav",
      quickSearchTag: "tagSearch",
      pageMenuItems: [
        {
          label: "tagImportBreadcrumbButton",
          routerLink: "/administration/import-tags",
          permissions: [adminPermissions.Tags.Write]
        }
      ],
      tagFilter: {
        accessible: true
      }
    }
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(tagManagerFeatureRoutes),
    TagManagerShellModule,
    NgxsModule.forFeature([TagManagerState, UiSchemaState, JsonSchemaState, TagsState]),
    RequestMetaDataStateModule
  ],
  providers: [RequestMetaDataResolverService, FilteredTagsResolverService]
})
export class TagManagerFeatureModule {}
